import React, { useState } from 'react';
import { Modal, Fade } from '@mui/material';
import { styled } from '@mui/material/styles';
import Network from './Requests';
import { useTranslation } from "react-i18next";

const PaperContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: '1px solid #000',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(4, 6, 5),
  borderRadius: 8,
}));

const ExportExel = (props) => {
  const [open, setOpen] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const { t } = useTranslation();

  const handleOpen = () => setOpen(true);

  const storage = localStorage.getItem('company');
  const storageCompany = JSON.parse(storage || 'null');

  const handleClose = async () => {
    try {
      await new Network().GetChatsExcel(
        storageCompany?.id,
        new Date(fromDate),
        new Date(toDate),
      );
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
    setOpen(false);
  };

  const handleFromDateChange = (event) => {
    const val = event.target.value;
    setFromDate(val);
    if (val > toDate) setToDate('');
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  return (
    <>
      <div>
        <Modal
          aria-labelledby="date-range-modal-title"
          aria-describedby="date-range-modal-description"
          open={open}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0
          }}
          onClose={handleClose}
          closeAfterTransition
        >
          <Fade in={open}>
            <PaperContainer>
              <div className="infoList--title">{ t("menu.exportCrmToExcel") }</div>

              <div style={{ marginBottom: '20px' }}>
                <label className="input-title">
                  { t("exportExcel.labels.fromDate") }
                </label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={handleFromDateChange}
                />
              </div>

              <div>
                <label className="input-title">
                  { t("exportExcel.labels.toDate") }
                </label>
                <input
                  type="date"
                  value={toDate}
                  onChange={handleToDateChange}
                  min={fromDate}
                />
              </div>

              <button
                type="submit"
                onClick={handleClose}
                style={{ marginTop: 20 }}
              >
                { t("exportExcel.actions.export") }
              </button>
            </PaperContainer>
          </Fade>
        </Modal>

        <div className="bm-item menu-item" onClick={handleOpen}>
          { t("menu.exportCrmToExcel") }
        </div>
      </div>
    </>
  );
};

export default ExportExel;
